export enum DocumentTypeEnum {
  Incoming = "1",
  Outgoing = "2",
  Request = "3"
}
  